import type { EnemyRoleId } from "../content/schemas";
import { ENEMY_TIER_INTERVAL } from "./constants";

export type SpawnTierMult = { hull: number; damage: number; speed: number };

export const SPAWN_TIER_MULT: SpawnTierMult[] = [
  { hull: 1, damage: 1, speed: 1 },
  { hull: 1.15, damage: 1.08, speed: 1.05 },
  { hull: 1.35, damage: 1.15, speed: 1.08 },
  { hull: 1.55, damage: 1.22, speed: 1.1 },
];

export function spawnTierForLevel(level: number): number {
  return Math.min(3, Math.floor(level / ENEMY_TIER_INTERVAL));
}

export function tierMultForLevel(level: number): SpawnTierMult {
  return SPAWN_TIER_MULT[spawnTierForLevel(level)]!;
}

export function threatGradeForLevel(level: number): number {
  return Math.min(8, 1 + spawnTierForLevel(level) + Math.floor((level - 1) / 6));
}

/** Min pilot level to spawn role in director pool. */
export const ROLE_MIN_LEVEL: Partial<Record<EnemyRoleId, number>> = {
  breacher: 4,
  jammer: 6,
  carrier: 8,
  sniper: 10,
  scavenger: 12,
  tender: 14,
  marauder: 16,
  sapper: 18,
  nullifier: 20,
  leech: 22,
  warden: 99,
  harvester: 99,
  sovereign: 99,
  leviathan: 99,
  null_crown: 99,
  centurion: 99,
  ace: 99,
};

/** Meta-rank gates add new threats to later-career expeditions. */
export const ROLE_MIN_PILOT_RANK: Partial<Record<EnemyRoleId, number>> = {
  sniper: 18,
  scavenger: 28,
  tender: 46,
  marauder: 54,
  sapper: 66,
  nullifier: 76,
  leech: 88,
  warden: 22,
  harvester: 36,
  sovereign: 50,
  leviathan: 60,
  null_crown: 80,
  centurion: 100,
};

export function roleAllowedAtLevel(roleId: EnemyRoleId, level: number): boolean {
  const min = ROLE_MIN_LEVEL[roleId];
  return min == null || level >= min;
}

export function roleAllowedAtPilotRank(roleId: EnemyRoleId, pilotRank: number): boolean {
  const min = ROLE_MIN_PILOT_RANK[roleId];
  return min == null || pilotRank >= min;
}
